import loadableWithRetry from '../common/loadableWithRetry'

const Profile = loadableWithRetry(() => import('./Profile'))

export default Profile;
